import { alpha } from '@mui/material/styles';

// ----------------------------------------------------------------------

// SETUP COLORS

const GREY = {
  0: '#FFFFFF',
  100: '#F9FAFB',
  200: '#F4F6F8',
  300: '#DFE3E8',
  400: '#C4CDD5',
  500: '#919EAB',
  600: '#637381',
  700: '#454F5B',
  800: '#212B36',
  900: '#161C24',
};

// Official MEITD identity: Sarawak crimson primary + institutional navy
// secondary, with restrained semantic ramps suited to a government system.
const PRIMARY = {
  lighter: '#F7E2E5',
  light: '#CF6B77',
  main: '#A81D2D',
  dark: '#7E1522',
  darker: '#520C16',
  contrastText: '#fff',
};

const SECONDARY = {
  lighter: '#DDE3F1',
  light: '#93A1C6',
  main: '#2A3558',
  dark: '#1B2340',
  darker: '#0E1322',
  contrastText: '#fff',
};

const INFO = {
  lighter: '#E3EFFB',
  light: '#7FB0E8',
  main: '#2A78D6',
  dark: '#1B54A0',
  darker: '#0F3468',
  contrastText: '#fff',
};

const SUCCESS = {
  lighter: '#DDF5EA',
  light: '#77D3AC',
  main: '#1E9E6A',
  dark: '#147A52',
  darker: '#0B4E36',
  contrastText: '#fff',
};

const WARNING = {
  lighter: '#FDF3DC',
  light: '#F6CE74',
  main: '#E9A115',
  dark: '#A96F09',
  darker: '#6B4405',
  contrastText: GREY[800],
};

const ERROR = {
  lighter: '#FDE8E8',
  light: '#F49898',
  main: '#DC2626',
  dark: '#A31616',
  darker: '#6E0D0D',
  contrastText: '#fff',
};

const COMMON = {
  common: { black: '#000', white: '#fff' },
  primary: PRIMARY,
  secondary: SECONDARY,
  info: INFO,
  success: SUCCESS,
  warning: WARNING,
  error: ERROR,
  grey: GREY,
  divider: alpha(GREY[500], 0.24),
  action: {
    hover: alpha(GREY[500], 0.08),
    selected: alpha(GREY[500], 0.16),
    disabled: alpha(GREY[500], 0.8),
    disabledBackground: alpha(GREY[500], 0.24),
    focus: alpha(GREY[500], 0.24),
    hoverOpacity: 0.08,
    disabledOpacity: 0.48,
  },
};

export default function palette(themeMode) {
  const light = {
    ...COMMON,
    mode: 'light',
    text: {
      primary: GREY[800],
      secondary: GREY[600],
      disabled: GREY[500],
    },
    background: { paper: '#fff', default: '#fff', neutral: GREY[200] },
    action: {
      ...COMMON.action,
      active: GREY[600],
    },
  };

  const dark = {
    ...COMMON,
    mode: 'dark',
    text: {
      primary: '#fff',
      secondary: GREY[500],
      disabled: GREY[600],
    },
    background: {
      paper: GREY[800],
      default: GREY[900],
      neutral: alpha(GREY[500], 0.16),
    },
    action: {
      ...COMMON.action,
      active: GREY[500],
    },
  };

  return themeMode === 'light' ? light : dark;
}
